'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { setToString } from '../../../core/utilities/set.utils.js';
import { removeCoreProps } from '../core/core.utils.js';
import { ComboboxInput } from './combobox-input.component.js';
import { ComboboxList } from './combobox-list.component.js';
import { ComboboxPopover } from './combobox-popover.component.js';
import { Combobox } from './combobox.component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { processStyleProps } from '../../../core/utilities/swan-style.js';

function _define_property(e, o, t) {
    return o in e ? Object.defineProperty(e, o, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[o] = t, e;
}
function _object_spread(e) {
    for(var o = 1; o < arguments.length; o++){
        var t = null != arguments[o] ? arguments[o] : {}, r = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), r.forEach(function(o) {
            _define_property(e, o, t[o]);
        });
    }
    return e;
}
function _object_without_properties(e, o) {
    if (null == e) return {};
    var t, r, i = _object_without_properties_loose(e, o);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)t = n[r], !(o.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (i[t] = e[t]);
    }
    return i;
}
function _object_without_properties_loose(e, o) {
    if (null == e) return {};
    var t, r, i = {}, n = Object.keys(e);
    for(r = 0; r < n.length; r++)t = n[r], o.indexOf(t) >= 0 || (i[t] = e[t]);
    return i;
}
const BasicCombobox = renderWithRef('BasicCombobox', void 0, (n, s)=>{
    let { 'aria-label': b, 'aria-labelledby': p, onSelectionChange: u, disableAutoFilter: f, selectedKey: y, inModal: _, children: d, allowsCustomValue: j, items: g, menuTrigger: h = 'input', maxHeight: O } = n, x = _object_without_properties(n, [
        'aria-label',
        'aria-labelledby',
        "onSelectionChange",
        "disableAutoFilter",
        "selectedKey",
        "inModal",
        "children",
        "allowsCustomValue",
        "items",
        "menuTrigger",
        "maxHeight"
    ]);
    return jsxs(Combobox, {
        items: g,
        onSelectionChange: u,
        disableAutoFilter: f,
        selectedKey: y,
        "aria-label": b,
        "aria-labelledby": p,
        className: setToString(processStyleProps(x, x.className ? [
            x.className
        ] : null)),
        allowsCustomValue: j,
        menuTrigger: h,
        maxHeight: O,
        children: [
            jsx(ComboboxInput, _object_spread({
                ref: s
            }, removeCoreProps(x))),
            jsx(ComboboxPopover, {
                inModal: _,
                children: jsx(ComboboxList, {
                    children: d
                })
            })
        ]
    });
});

export { BasicCombobox };
